export const htmlToText = (html: string) => {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html

    return wrapper.innerText
}
